export class TypeCheckboxFilter {
    constructor(selector) {
        this.typeInput = $(selector);
        this._checkedUnitType = [];
    }

    // filter(asset)
    // {
    //     if( this._checkedUnitType.includes(asset.data('type')) )
    //     {
    //         console.log(this._checkedUnitType);
    //         console.log(asset.data('type'));
    //         return true;
    //     }
    //     else
    //     {

    //         return false;
    //     }
    // }

    filter(asset) {
        //if( this._checkedUnitType.includes(asset.data('type')) )
        //console.log(typeof(asset.data('type')));

        // check if all unchecked, if so don't filter by
        if (this._checkedUnitType.length == 0)
            return true;

        let type = asset.data('type').toString();
        // if the type number exists in the array in any position
        if (this._checkedUnitType.some(r => type.indexOf(r) >= 0)) {
            //console.log(this._checkedUnitType);
            //console.log(asset.data('type'));              
            return true;
        }
        else {
            return false;
        }
    }

    updateValues() {
        this._checkedUnitType = [];

        this.typeInput.each((index, element) => {
            if ($(element).is(':checked')) {
                //console.log(this._checkedUnitType);
                // console.log(parseInt( $(element).val());
                this._checkedUnitType.push($(element).val());
            }
        });
    }

    getValues() {
        return this._checkedUnitType;
    }

}